import { configureStore } from '@reduxjs/toolkit';
import formReducer from './slices/formSlice';

// Simplified store without sagas to prevent blocking
export const store = configureStore({
  reducer: {
    form: formReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;

